<header class="sticky-top">
  <app-navbar></app-navbar>
</header>
<main>
  <router-outlet></router-outlet>
</main>
<footer>
  <app-footer></app-footer>
</footer>
<ngx-ui-loader></ngx-ui-loader>